import { render } from "./VanguardLabel.vue?vue&type=template&id=49d8d194"
import script from "./VanguardLabel.vue?vue&type=script&lang=js"
export * from "./VanguardLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__